import Loadable from 'react-loadable';
import Loading from 'components/Loading';
import {AppSettings} from '../constants';
// import ManageTrades from './Containers/manage-trades';

const ManageTrades = Loadable({
  loader: () => import('./Containers/manage-trades'),
  loading: Loading
});

export default [
  {
    path: '/trades',
    component: ManageTrades,
    portal: ['System'],
    private: true,
    menu: {
      name: 'Trades',
      group: 'Admin',
      order: 3,
      subGroup: 'Other',
      icons: 'icon-trades-ic',
      condition: () => {
        return AppSettings.CURRENT_SITE_URI === AppSettings.SITE_ONE_SERVICE_URI;
      }
    }
  }
];



// WEBPACK FOOTER //
// ./src/Trades/routes.js